import "./Testimonials.css";

const testimonials = [
    {
        name: "Leading Tech Corp",
        role: "Director of Marketing",
        feedback:
            "Cabptoid Solutions helped us increase our website traffic by 300% and generate high-quality leads that converted into loyal customers."
    },
    {
        name: "Global E-commerce Brand",
        role: "Founder & CEO",
        feedback:
            "Their digital marketing strategy significantly improved our online presence and lowered our customer acquisition cost drastically."
    },
    {
        name: "Regional Industrial Leader",
        role: "Operations Manager",
        feedback:
            "The precision in their SEO and PPC execution is unmatched. We saw a measurable ROI within the first three months of partnership."
    }
];

function Testimonials() {
    return (
        <section className="testimonials">
            <div className="testimonials-container">
                <div className="testimonials-header">
                    <h2>Discover what our clients have to say about our <span className="highlight">solutions</span></h2>
                    <p>Trust is built on results. Here’s how we’ve helped businesses scale their digital presence.</p>
                </div>

                <div className="testimonial-grid">
                    {testimonials.map((client, index) => (
                        <div className="testimonial-card" key={index}>
                            <div className="quote-icon">“</div>
                            <p className="feedback">{client.feedback}</p>
                            <div className="client-info">
                                <h4>{client.name}</h4>
                                <span>{client.role}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Testimonials;